import React from "react";
import { FaCheck, FaDollarSign, FaGift } from "react-icons/fa";

export const INSTALLMENT_QUEUE_TABS = [
  { id: "commission", label: "Fee installments" },
  { id: "bonus", label: "Bonus installments" },
];

const CARD_CONFIG = {
  commission: {
    icon: FaDollarSign,
    accent: "#10B981",
    accentBg: "bg-emerald-50",
    accentText: "text-emerald-600",
    accentRing: "ring-emerald-200",
    countKey: "awaitingCommission",
  },
  bonus: {
    icon: FaGift,
    accent: "#8B5CF6",
    accentBg: "bg-violet-50",
    accentText: "text-violet-600",
    accentRing: "ring-violet-200",
    countKey: "awaitingBonus",
  },
};

function CommissionInstallmentsQueueTabs({
  value = "commission",
  counts = null,
  onChange,
}) {
  return (
    <div className="flex flex-wrap justify-center gap-3">
      {INSTALLMENT_QUEUE_TABS.map((tab) => {
        const cfg = CARD_CONFIG[tab.id];
        const Icon = cfg.icon;
        const active = value === tab.id;
        const count = counts?.[cfg.countKey];
        const hasCount = Number.isFinite(Number(count));

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange?.(tab.id)}
            className={`cms-commissions-report-tab group relative flex w-full min-w-0 max-w-none flex-1 items-center gap-3 overflow-hidden rounded-xl border bg-white px-4 py-3 text-left transition-all duration-200 sm:min-w-[200px] sm:max-w-[320px] ${
              active
                ? `border-transparent shadow-md ring-2 ring-inset ${cfg.accentRing}`
                : "border-gray-200 shadow-sm hover:-translate-y-0.5 hover:shadow-md"
            }`}
            style={{ outline: "none" }}
          >
            {active ? (
              <span
                className="absolute inset-x-0 top-0 h-[3px] rounded-t-xl"
                style={{ backgroundColor: cfg.accent }}
                aria-hidden
              />
            ) : null}

            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${cfg.accentBg} ${cfg.accentText}`}
            >
              <Icon size={18} />
            </span>

            <div className="min-w-0 flex-1">
              <p
                className={`truncate text-[13px] font-semibold leading-tight ${
                  active ? "text-gray-900" : "text-gray-700"
                }`}
              >
                {tab.label}
              </p>
              {hasCount ? (
                <p className="mb-0 mt-0.5 truncate text-[11px] font-medium tabular-nums text-gray-500">
                  {count} awaiting payment
                </p>
              ) : null}
            </div>

            {active ? (
              <span
                className="absolute right-2.5 top-2.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-white"
                style={{ backgroundColor: cfg.accent }}
              >
                <FaCheck size={7} />
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default CommissionInstallmentsQueueTabs;
